<template>
  <section class="hero-section hero-animate" :class="customClass">
    <div class="container">
      <div class="row">
        <div :class="containerClass">
          <h1 class="hero-title" v-if="title">{{ title }}</h1>
          <h3 class="hero-subtitle" v-if="subtitle">{{ subtitle }}</h3>
          <p class="hero-description" v-if="description">{{ description }}</p>
          <div class="hero-buttons" v-if="$slots.buttons || buttons">
            <slot name="buttons">
              <router-link 
                v-for="(button, index) in buttons" 
                :key="index"
                :to="button.to" 
                :class="button.class || 'btn btn-primary-hero btn-lg'"
                @click="button.onClick"
              >
                {{ button.text }}
              </router-link>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HeroSection",
  props: {
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    buttons: {
      type: Array,
      default: () => []
    },
    containerClass: {
      type: String,
      default: "col-lg-10 mx-auto text-center"
    },
    customClass: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
// Importar variables de color centralizadas
@import '../styles/variables';

.hero-section {
  background: $landing-primary-gradient;
  padding: 100px 0;
  color: white;
  
  .hero-title {
    font-size: 3.5rem;
    font-weight: 700;
    margin-bottom: 2rem;
    color: white;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    
    @media (max-width: 768px) {
      font-size: 2.5rem;
    }
  }
  
  .hero-subtitle {
    font-size: 1.8rem;
    color: white;
    font-weight: 700;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    margin-bottom: 1.5rem;
    
    @media (max-width: 768px) {
      font-size: 1.6rem;
    }
  }
  
  .hero-description {
    font-size: 1.3rem;
    color: white;
    font-weight: 500;
    margin-bottom: 2rem;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
    
    @media (max-width: 768px) {
      font-size: 1.1rem;
    }
  }
  
  .btn-primary-hero {
    background: $landing-primary-color;
    color: white;
    border: none;
    border-radius: 50px;
    padding: 15px 40px;
    font-size: 1.1rem;
    font-weight: 700;
    transition: all 0.3s ease;
    text-decoration: none;
    display: inline-block;
    
    &:hover {
      background: $landing-primary-dark;
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(255, 107, 53, 0.4);
      color: white;
      text-decoration: none;
    }
  }
}
</style>
